import sandbox from '../../sandbox';

const execute = async (apiCall: any, path: string, payload?: any, headers?: any, overrideAuth?: string, onDownloadProgress?: (progressEvent: any) => void) => {
    const viewAs: string | null = sandbox.get('viewAs');

    try {
        const response = await apiCall(path, payload, viewAs, headers, overrideAuth, onDownloadProgress);
        if (response.body instanceof ReadableStream) {
            try {
                const body = await response.json();
                return {
                    ...payload,
                    data: body,
                };
            } catch (error: any) {
                return {
                    ...payload,
                    ...error,
                };
            }
        }
        return {
            ...payload,
            ...response,
        };
    } catch (error: any) {
        console.error(error);
         
        throw {
            ...payload,
            ...error,
        };
    }
};

export default execute;
